export default (state = false, action) => {
    let { type, payload } = action
    switch (type) {
        case 'OPEN_THREED_WELCOME_POPUP':
            return true
        case 'CLOSE_THREED_WELCOME_POPUP':
            return false
        case 'LOGOUT':
            return false
        default:
            return state
    }
}
